import { useTranslation } from '@stepstone-platform/i18n';
export const useBuildBenefitsLabels = (brand) => {
    const { t } = useTranslation();
    const benefits = [
        t('loginregistration.fullscreenModalContent.benefits.benefit1'),
        t('loginregistration.fullscreenModalContent.benefits.benefit2'),
        t('loginregistration.fullscreenModalContent.benefits.benefit3'),
    ];
    brand === 'pnet' && benefits.pop();
    return benefits;
};
//# sourceMappingURL=useBuildBenefitsLabels.js.map